import services from 'services/services';

// Import types
import type {
	CalculatedPrice,
	CalculatePriceAction,
	UserSubscription,
	CalculatePricePayloadProduct,
	SubscriptionSettings
} from 'types/api/packetsSubscription';

export const fetchCalculatePrice = async (
	products: CalculatePricePayloadProduct[],
	action: CalculatePriceAction,
	isAuth = true
): Promise<CalculatedPrice> => {
	const url = isAuth ? '/packetsSubscription/calculatePrice' : '/packetsSubscription/calculatePriceAnonymous';
	return await services.post<CalculatedPrice>(url, { action, products }).then((response) => response.data);
};

export const fetchCurrentSubscription = async (): Promise<UserSubscription | null> => {
	return await services
		.get<UserSubscription>('/packetsSubscription/details')
		.then((response) => response.data)
		.catch((error) => {
			if (error?.response?.status === 404) {
				return null;
			} else {
				return Promise.reject();
			}
		});
};

export const fetchSubscriptionSettings = async () => {
	return services.get<SubscriptionSettings>('/packetsSubscription/settings').then((response) => response.data);
};

export const sendPrePaymentMail = ({ main, premium }: { main: CalculatePricePayloadProduct | null; premium: CalculatePricePayloadProduct[] }) =>
	services.post('/packetsSubscription/sendPrePaymentMail', {
		basic_product: main,
		additional_products: premium
	});
